import { render, staticRenderFns } from "./SubprogramsList.vue?vue&type=template&id=3b430672&scoped=true&"
import script from "./SubprogramsList.vue?vue&type=script&lang=js&"
export * from "./SubprogramsList.vue?vue&type=script&lang=js&"
import style0 from "./SubprogramsList.vue?vue&type=style&index=0&id=3b430672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b430672",
  null
  
)

export default component.exports